export default "__VITE_ASSET__isWv$6Xt__"